"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Scope;
(function (Scope) {
    Scope["USER"] = "USER";
    Scope["ORGANIZATION"] = "ORGANIZATION";
    Scope["INVITATION"] = "INVITATION";
    Scope["MEDIA"] = "MEDIA";
    Scope["PALETTE"] = "PALETTE";
    Scope["FONT"] = "FONT";
    Scope["EXPORT_SET"] = "EXPORT_SET";
    Scope["GALLERY"] = "GALLERY";
    Scope["TEMPLATE"] = "TEMPLATE";
    Scope["DATA_APP"] = "DATA_APP";
    Scope["CAMPAIGN"] = "CAMPAIGN";
    Scope["ITEM"] = "ITEM";
    Scope["DRIVE"] = "DRIVE";
    Scope["COLLECTION"] = "COLLECTION";
    Scope["BANNER"] = "BANNER";
    Scope["SCREEN_GROUP"] = "SCREEN_GROUP";
    Scope["SCREEN"] = "SCREEN";
    Scope["VIRTUAL_WINDOW"] = "VIRTUAL_WINDOW";
})(Scope = exports.Scope || (exports.Scope = {}));
var Action;
(function (Action) {
    Action["CREATE"] = "CREATE";
    Action["READ"] = "READ";
    Action["UPDATE"] = "UPDATE";
    Action["DELETE"] = "DELETE";
    Action["CLONE"] = "CLONE";
})(Action = exports.Action || (exports.Action = {}));
//# sourceMappingURL=User.js.map